import { OVERLAY_ATTRIBUTE, OVERLAY_OPACITY_ATTRIBUTE } from '../constants/display-options';

const isOverlayTouched = (displayOptions) =>
  displayOptions.some(
    ({ attribute, touched }) =>
      [OVERLAY_ATTRIBUTE, OVERLAY_OPACITY_ATTRIBUTE].includes(attribute) && touched
  );

export default isOverlayTouched;
